import { Component, OnInit, input } from '@angular/core';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-academic',
    templateUrl: './academic.component.html',
    styleUrl: './academic.component.scss',
    imports: [DatePipe]
})
export class AcademicComponent implements OnInit {
	readonly academic = input<any>();
	readonly settings = input<any>();

	public isEducationSectionView: boolean;
	public isAwardsSectionView: boolean;
	public isCertificationSectionView: boolean;

	ngOnInit(): void {
		this.isEducationSectionView = this.settings()
			?.filter((e: any) => e.name == 'Education History')
			.map((e: any) => e.active)[0];
		const settings = this.settings();
  this.isAwardsSectionView = settings
			?.filter((e: any) => e.name == 'Awards and Honors')
			.map((e: any) => e.active)[0];
		this.isCertificationSectionView = settings
			?.filter((e: any) => e.name == 'Licenses and Certifications')
			.map((e: any) => e.active)[0];
	}
}
